// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../../primary-message/components/PrimaryMessageContentSection';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { getFullUrl } from 'hubspot-url-utils';
import WorkflowGeneratedUserHeaderAttachment from './WorkflowGeneratedUserHeaderAttachment';
import { getHeaderAttachment, getQuickRpliesAttachment, getMessageText, isPlainText } from 'conversations-message-history/workflow-generated-user-message/operators/workflowGeneratedUserMessageGetters';
import QuickRepliesAttachment from '../../attachments/QuickRepliesAttachment';
import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import SlottedMessage from '../../slotted-message/SlottedMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import ContentText from '../../primary-message/ContentText';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import AutomatedMessageAvatar from '../../avatar/AutomatedMessageAvatar';
import DeliveryStatusFooter from '../../delivery-status/DeliveryStatusFooter';
import { Text } from 'foundations-components/components/Text';
import { WarningIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WorkflowGeneratedUserMessageBody = ({
  headerAttachment,
  fileAttachments,
  genericChannelId,
  messageText,
  quickRepliesAttachment,
  isContentPlainText
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(WorkflowGeneratedUserHeaderAttachment, {
    headerAttachment: headerAttachment,
    fileAttachments: fileAttachments,
    genericChannelId: genericChannelId
  }), /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    canExpand: true,
    genericChannelId: genericChannelId,
    isLastMessage: true,
    children: /*#__PURE__*/_jsx(ContentText, {
      contentText: messageText,
      isPlainText: isContentPlainText
    })
  }), quickRepliesAttachment ? /*#__PURE__*/_jsx(QuickRepliesAttachment, {
    quickRepliesAttachment: quickRepliesAttachment
  }) : null]
});
WorkflowGeneratedUserMessageBody.displayName = 'WorkflowGeneratedUserMessageBody';
const WorkflowGeneratedUserMessage = ({
  message,
  fileAttachments,
  positionDescriptors,
  visitorLastReadTimestamp,
  workflowName
}) => {
  var _message$status;
  const headerAttachment = getHeaderAttachment(message);
  const messageText = getMessageText(message);
  const quickRepliesAttachment = getQuickRpliesAttachment(message);
  const genericChannelId = getGenericChannelId(message);
  const timestamp = getTimestamp(message);
  const workflowUrl = `${getFullUrl('app')}/workflows/${PortalIdParser.get()}/platform/flow/${message.flowId}`;
  return /*#__PURE__*/_jsx(SlottedMessage, {
    container: {
      componentProps: {
        'data-test-id': 'primary-message-AUTOMATED',
        use: AGENT
      }
    },
    avatar: {
      Component: AutomatedMessageAvatar
    },
    title: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.responder.automatic'
      }
    },
    timestamp: {
      componentProps: {
        timestamp
      }
    },
    body: {
      Component: WorkflowGeneratedUserMessageBody,
      componentProps: {
        headerAttachment,
        fileAttachments,
        genericChannelId,
        messageText,
        quickRepliesAttachment,
        isContentPlainText: isPlainText(message)
      }
    },
    footerTitle: {
      Component: FormattedMessage,
      componentProps: {
        message: 'conversations-inbox-message-history.workflow-generated-user-message.source-workflow'
      }
    },
    footerBody: {
      Component: Link,
      componentProps: {
        use: 'blue',
        href: workflowUrl,
        truncate: true,
        external: true,
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: workflowName || workflowUrl
        })
      }
    },
    annotation: ((_message$status = message.status) === null || _message$status === void 0 ? void 0 : _message$status.messageStatus) === 'FAILED' ? {
      Component: Text,
      componentProps: {
        color: 'text-alert-default',
        typography: 'detail-200',
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            children: [/*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              alignItems: "center",
              marginInlineEnd: "100",
              children: /*#__PURE__*/_jsx(WarningIcon, {})
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.DEFAULT"
            })]
          })
        })
      }
    } : {
      Component: DeliveryStatusFooter,
      componentProps: {
        timestamp,
        status: message.status,
        positionDescriptors,
        visitorLastReadTimestamp
      }
    }
  });
};
WorkflowGeneratedUserMessage.displayName = 'WorkflowGeneratedUserMessage';
export default WorkflowGeneratedUserMessage;